import { Outlet, useLocation } from "react-router-dom";
import FloatNav from "../components/Layout/FloatNav";
import Header from "../components/Layout/Header/index";
import Contexts from "../contexts/Contexts";
import { useContext } from "react";
import Footer from "../components/Layout/Footer";
import RightSide from "../components/Layout/RightSide";
import CriarContaBar from "../components/CriarContaBar";
import AffiliateRibbon from "../components/Affiliate/AffiliateRibbon";
import AffiliateSidebarCrest from "../components/Affiliate/AffiliateSidebarCrest";

const Layout = ({
  sideBar = false,
  showFilter = false,
  floatNav = true,
}: {
  sideBar?: boolean;
  showFilter?: boolean;
  floatNav?: boolean;
}) => {
  const { screenSize } = useContext(Contexts);
  const { pathname } = useLocation();

  // Hide FloatNav on DareView page for mobile devices
  const isDareViewPage =
    pathname.includes("/challenge/") && pathname !== "/challenge";
  const hideFloatNav =
    !floatNav ||
    (isDareViewPage && !screenSize.isDesktop) ||
    pathname === "/components";

  return screenSize.isDesktop ? (
    <div>
      <Header showFilter={showFilter} />
      <AffiliateRibbon />
      <main className="main-content">
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <AffiliateSidebarCrest />
          <FloatNav />
        </div>
        <div className="pc-main-content">
          <Outlet />
        </div>
        {sideBar && <RightSide />}
      </main>
      <Footer />
      <CriarContaBar />
    </div>
  ) : (
    <div className={showFilter ? "show-mobile-header-filter" : ""}>
      <Header showFilter={showFilter} />
      <AffiliateRibbon />
      <main className="main-content">
        <Outlet />
      </main>
      {!hideFloatNav && <FloatNav />}
      <CriarContaBar />
    </div>
  );
};
export default Layout;
